import { apiAxios } from '../../../helpers'

export const getTotalMatches = async (commit, params) => {
  commit('updateLoading', true)
  const result = await apiAxios.get('stats/totalMatches', { params })
  commit('updateLoading', false)
  return result.data.data.stats
}

export const getAverages = async (commit, params) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get('stats/averages', { params })
    .finally(_ => commit('updateLoading', false))

  return result.data.data.stats
}
export const getAveragesPhases = async (commit, params) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get('stats/averagesPhases', { params })
    .finally(_ => commit('updateLoading', false))

  return result.data.data.stats
}

export const getTotalStats = async commit => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get('stats/totalStats')
    .finally(_ => commit('updateLoading', false))

  return result.data.data.stats
}
export const getTotalUsers = async (commit, params) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get('stats/totalUsers', { params })
    .finally(_ => commit('updateLoading', false))

  return result.data.data.stats
}
